import jwt_decode from 'jwt-decode';
import 'custom-event-polyfill';
import chevronIcon from '../../assets/images/icons/chevron-right.svg';
import '../../scripts/global-menu-generic-icon';
import {
  defaultConfig,
  eventContextChanged,
  eventContextSwitcherReady,
  eventFavoritesUpdated
} from './cam-context-switcher-constants';
import camContextSwitcherDatastore from './cam-context-switcher-datastore';
import './cam-context-switcher-panel';

const tagName = 'cam-context-switcher';
const template = require('../templates/cam-context-switcher.ejs');

export default class CamContextSwitcher extends HTMLElement {

  constructor(camContext) {
    super();
    this.datastore = camContextSwitcherDatastore;
    this.camContext = camContext;

  }

  connectedCallback() {
    this.id = tagName;
    this.classList.add(tagName);

    this.timeout = this.getAttribute('timeout') || 10000;

    document.addEventListener(eventContextChanged, this.handleContextChanged.bind(this));
    document.addEventListener(eventFavoritesUpdated, this.handleFavoritesUpdated.bind(this));

    this.dispatchEvent(new CustomEvent(eventContextSwitcherReady, { bubbles: true }));
  }

  disconnectedCallback() {
    document.removeEventListener(eventContextChanged, this.handleContextChanged.bind(this));
    document.removeEventListener(eventFavoritesUpdated, this.handleFavoritesUpdated.bind(this));
  }

  renderCamContextSwitcher() {
    let context = this.datastore.selectedContext;


    this.innerHTML = template({
      display: context.display,
      icons: {
        chevron: chevronIcon
      }
    });
  }

  camApi(endpoint, method='GET', payload=null) {
    let url = `${this.baseUrl}/${endpoint.replace(/^\/+/, '')}`;
    let httpConfig = {
      mode: 'cors',
      method: method,
      headers: {
        'Authorization': `Bearer ${this.token}`,
        'Content-Type': 'application/json'
      }
    };
    if (payload !== null) {
      httpConfig.body = JSON.stringify(payload);
    }
    return fetch(url, httpConfig).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        return res.json().then((res) => {
          return res;
        });
      } else {
        return Promise.reject(res);
      }
    });
  }

  populate(token, config={}) {
    config = Object.assign(defaultConfig, config);

    // Use mock data for live example
    if (window.mockContextSwitcherScopes) {
      console.warn('Context switcher was populated with Mock data');
      this.datastore.initializeData(
        window.mockContextSwitcherUser,
        window.mockContextSwitcherScopes,
        window.mockContextSwitcherPersonalWorkspace,
        this.camContext,
        config);
      return Promise.resolve(window.mockContextSwitcherScopes);
    }

    let jwt;
    try {
      jwt = jwt_decode(token);
    } catch(err) {
      return Promise.reject('Error decoding Token');
    }
    this.baseUrl = config.apiUrl.replace(/\/+$/, '');
    this.token = token;
    let userName = jwt.sub;

    return Promise.all([
      this.camApi('/services/scopes'),
      this.camApi(`/services/workspaces/${userName}`)
    ]).then((values) => {
      let [ scopesResponse, personalWorkspaceResponse ] = values;
      this.datastore.initializeData(userName, scopesResponse, personalWorkspaceResponse, this.camContext, config);
      return scopesResponse;
    });

  }

  handleContextChanged() {
    this.renderCamContextSwitcher();
  }

  handleFavoritesUpdated(e) {
    e.cancelBubble = true;

    let personalWorkspaceRequest = this.datastore.personalWorkspaceResponse;
    let favorites = this.datastore.personalWorkspaceResponse.favorites;

    let state = e.detail.state.toLowerCase();
    let context = e.detail.context;
    let idx = favorites.findIndex((f) => {return f.id === context.id && f.type === context.type;});
    if (state === 'present') {
      if (idx === -1) {
        favorites.push({
          type: context.type,
          id: context.id
        });
      }
    } else {
      if (idx !== -1) {
        favorites.splice(idx, 1);
      }
    }
    personalWorkspaceRequest.favorites = favorites;

    this.camApi(`/services/workspaces/${personalWorkspaceRequest.id}`, 'PUT', personalWorkspaceRequest).then((res) => {
      this.datastore.updatePersonalWorkspace(res);
      this.datastore.updateAllContexts();
      let camContextSwitcherPanel = document.querySelector('#cam-context-switcher-panel');
      camContextSwitcherPanel.renderPanel();
    });
  }
}

if (!customElements.get(tagName)) {
  customElements.define(tagName, CamContextSwitcher);
}



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher.js